
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus, Minus } from 'lucide-react';
import { Reveal } from './Reveal';

export const FAQ: React.FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      id: "SYS_01",
      question: t('faq.items.SYS_01.question'),
      answer: t('faq.items.SYS_01.answer')
    },
    {
      id: "SYS_02",
      question: t('faq.items.SYS_02.question'),
      answer: t('faq.items.SYS_02.answer')
    },
    {
      id: "SYS_03",
      question: t('faq.items.SYS_03.question'),
      answer: t('faq.items.SYS_03.answer')
    },
    {
      id: "SYS_04",
      question: t('faq.items.SYS_04.question'),
      answer: t('faq.items.SYS_04.answer')
    }
  ];

  return (
    <section id="pricing" className="py-20 md:py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header - Matching Branchenkompetenz Style */}
        <Reveal>
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-24 border-b border-gray-900 pb-8">
            <h2 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tighter leading-none">
              {t('faq.title_line1')}<br />{t('faq.title_line2')}
            </h2>
            <div className="text-right mt-8 md:mt-0">
              <p className="text-gray-500 text-lg max-w-md">
                {t('faq.subtitle')}
              </p>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col border-t border-gray-200">
          {faqs.map((faq, index) => (
            <Reveal key={index} delay={index * 0.1}>
              <div className={`group border-b border-gray-200 transition-colors duration-300 ${openIndex === index ? 'bg-gray-50' : 'hover:bg-gray-50'}`}>
                <button
                  className="w-full flex items-start md:items-center justify-between py-10 px-4 md:px-8 text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-12">
                    <span className="font-mono text-xs text-gray-400 uppercase tracking-widest">
                      // {faq.id}
                    </span>
                    <span className={`text-xl md:text-2xl font-bold transition-colors duration-300 ${openIndex === index ? 'text-clever-teal' : 'text-gray-900'}`}>
                      {faq.question}
                    </span>
                  </div>

                  <div className="ml-4 flex-shrink-0 text-gray-400 font-mono">
                    {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] ${openIndex === index ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}
                >
                  <div className="px-4 md:px-8 pb-10 grid grid-cols-1 md:grid-cols-12">
                    <div className="hidden md:block md:col-span-2"></div> {/* Spacer aligning with ID */}
                    <div className="md:col-span-8">
                      <div className="text-lg leading-relaxed text-gray-600 font-light pl-4 border-l border-clever-teal/30">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};
